export interface AmplifyAuthConfig {
  Auth: {
    // Amazon Cognito Identity Pool ID
    identityPoolId: string;
    // Amazon Cognito Region
    region: string;
    // Amazon Cognito User Pool ID
    userPoolId?: string;
    // Amazon Cognito Web Client ID
    userPoolWebClientId?: string;
    // Amazon Cookie Storage
    cookieStorage?: {
      domain: string;
      path: string;
      secure: boolean;
    };
    // (optional) - Hosted UI configuration
    oauth: {
      domain: string;
      scope: string[];
      redirectSignIn: string;
      redirectSignOut: string;
      clientId: string;
      responseType: string;
    };
  };
}

export interface AmplifyErrorObject extends Error {
  code?: string;
}

export type AmplifyError = string | AmplifyErrorObject;

export enum HostedUIIdentityProvider {
  Xero = 'Xero'
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface HubPayload {
  event: string;
  data?: any;
  message?: string;
}
export type HubCallback = (data: { payload: HubPayload }) => void;
/* eslint-enable @typescript-eslint/no-explicit-any */

export enum AmplifyException {
  UsernameExists = 'UsernameExistsException',
  UserLambdaValidation = 'UserLambdaValidationException',
  NotAuthorized = 'NotAuthorizedException'
}
